const CREATIVE_ENDPOINT = {
  ALL_VIDEOS: (brand: string): string => `/brands/${brand}/videos`,
  TAGS: (brand: string): string => `/brands/${brand}/tags`,
  VIDEOS_TAGS: (brand: string): string => `/brands/${brand}/tags`
};

export default CREATIVE_ENDPOINT;
